import React, { FC, memo } from 'react';

import Typography from '@mui/material/Typography';

import { RESOURCES_MOB } from '@constants/common/menu.constants';

import Card from '../Card';
import useStyles from './styles.module';

interface Props {
  onClose: () => void;
}

const Resources: FC<Props> = ({ onClose }) => {
  const { classes } = useStyles();

  const handleRedirect = (path: string) => {
    if (!path) return;

    window.open(path, '_self _blank');
    onClose();
  };

  return (
    <Card title="Resources">
      <Typography variant="caption1" color={(theme) => theme.primary.p2}>
        Learn about all of the complex functionality that dexVAULTS offers in
        our complete documentation
      </Typography>
      <div className={classes.content}>
        {RESOURCES_MOB.map(({ title, icon, href }) => (
          <button
            key={`sidebar-${href}`}
            className={classes.item}
            onClick={() => handleRedirect(href)}
          >
            {icon}
            <Typography variant="body1" color={(theme) => theme.primary.p2}>
              {title}
            </Typography>
          </button>
        ))}
      </div>
    </Card>
  );
};

export default memo(Resources);
